import Icon from 'antd/lib/icon'

import 'antd/lib/icon/style'

export * from 'antd/lib/icon'

export default Icon
